import React from 'react';

import { Box, Button, Paper, Typography } from 'components';
import { DirectInbox, FilterRemove } from 'iconsax-react';

import { useTranslation } from 'third-party';

import { palette } from 'styles/theme';

type Props = {
  showResetFilterButton?: boolean;
  onFilterReset?: () => void;
};

export const EmptyState: React.FC<Props> = ({
  showResetFilterButton,
  onFilterReset,
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 'calc(100vh - 200px)',
        minHeight: '400px',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: '600px',
          width: '100%',
          py: 6,
          px: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'background.default',
          border: 'none',
          borderRadius: '8px',
        }}
      >
        <DirectInbox
          variant="TwoTone"
          size="4rem"
          color={palette.primary900}
          style={{ marginBottom: '16px', opacity: 0.9 }}
        />
        <Typography variant="h2" color="primary" gutterBottom>
          {t('common.emptyState')}
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center">
          {t('common.emptyState.description')}
        </Typography>

        {showResetFilterButton && onFilterReset && (
          <Button
            variant="outlined"
            onClick={onFilterReset}
            startIcon={<FilterRemove variant="TwoTone" size="24" />}
            sx={{ mt: 3 }}
          >
            {t('common.emptyState.clearFilters')}
          </Button>
        )}
      </Paper>
    </Box>
  );
};
